export const UPLOAD_STATUS = {
    DONE: 'DONE',
    UPLOADING: 'UPLOADING',
    COMPLETING: 'COMPLETING',
    FILE_COPPING: 'FILE_COPPING',
    FILE_MOVING: 'FILE_MOVING',
    FOLDER_COPPING: 'FOLDER_COPPING',
    FOLDER_MOVING: 'FOLDER_MOVING',
}

export const LAYOUTS = {
    LIST: "LIST",
    GRID: "GRID"
}

export const DRIVE_TYPES = {
    SHARED: "shared"
}

export const PERMISSIONS = {
    WRITE: "WRITE",
    VIEW: "VIEW"
}